import {combineReducers} from 'redux';
import configs from 'redux/reducers/config';

export default combineReducers({
    configs
});
